import React, { useState } from 'react';

import { Select } from 'antd';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useLazyQuery, useMutation } from '@apollo/client';

import Modal from 'common/components/modal';
import { QUERY_LIST_PMS, MUTATION_ISSUE_INTEGRATION_WITH_PMS } from '../../../query';
import { PMSStatusEnum } from '../constants';

const ChoosePMSModal = ({ visible, onCancel, form, landlord, getLandlord }) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const { t } = useTranslation();

  const [pmsList, setPmsList] = useState([]);

  const [queryPMSList, { loading: queryPMSListLoading }] = useLazyQuery(QUERY_LIST_PMS, {
    onCompleted: res => {
      const result = res?.listPMS?.pms ?? [];
      if (result.length > 0) {
        const pmsListArray = [];
        for (let i = 0; i < result.length; i++) {
          if (result[i].status === PMSStatusEnum.AT_WORK) {
            pmsListArray.push(result[i]);
          }
        }
        setPmsList(pmsListArray);
      }
    },
  });

  const [updatePMS, { loading: submitLoading }] = useMutation(MUTATION_ISSUE_INTEGRATION_WITH_PMS, {
    onCompleted: res => {
      if (res?.issueIntegrationWithPMS?.activationToken) {
        getLandlord();
        onCancel();
        resetFields();
      }
    },
  });

  const handleCancel = () => {
    onCancel();
    resetFields();
  };

  const onOk = () => {
    validateFields((error, values) => {
      if (!error) {
        updatePMS({
          variables: {
            input: {
              pmsId: values.pmsId,
              landlordId: landlord?.id,
            },
          },
        });
      }
    });
  };

  return (
    <Modal
      title="Choose PMS"
      width={414}
      visible={visible}
      okText={t('cms.properties.edit.leave_alert.title')}
      cancelText={t('cms.landlord.modal.cancel.button')}
      wrapClassName="choose-pms-modal"
      onCancel={handleCancel}
      onOk={onOk}
      cancelButtonProps={{
        className: 'ant-btn-cancel',
      }}
      okButtonProps={{
        loading: submitLoading,
        className: 'ant-btn-confirm',
      }}
    >
      <Form>
        <Form.Item label={t('PMS name')}>
          {getFieldDecorator('pmsId', {
            rules: [
              {
                required: true,
                message: t(
                  'cms.landlord.detail.token.pms_channel_integration.choose_pms.pms_name.error',
                ),
              },
            ],
          })(
            <Select
              onDropdownVisibleChange={queryPMSList}
              placeholder={t('cms.landlord.modal.not_specific.placeholder')}
              loading={queryPMSListLoading}
            >
              <For of={pmsList} each="option" index="index">
                <Select.Option key={index} value={option.id}>
                  {option.name}
                </Select.Option>
              </For>
            </Select>,
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};
ChoosePMSModal.propTypes = {
  form: PropTypes.object.isRequired,
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default Form.create()(ChoosePMSModal);
